var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"div-loader"}},[_c('div',{staticClass:"w-100 height-100 d-flex align-items-center"},[_c('div',{staticClass:"div-loader m-auto"},[_c('img',{attrs:{"src":require("@/assets/loader.gif")}}),_c('div',{staticClass:"text-subheading text-center"},[_vm._v("Loading")])])])])
}]

export { render, staticRenderFns }